// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__eQYP5","link":"default_link__qT06P"};